var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    (_vm.reply.ownable.id === _vm.loggedInAs.id && !_vm.reply.by_admin) ||
    _vm.loggedInAs.type === "App\\User"
      ? _c(
          "div",
          {
            staticClass: "dropdown position-absolute",
            staticStyle: { top: "0", right: "0" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.remove.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("translate")("Delete")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-auto" },
        [_c("Avatar", { attrs: { user: _vm.student, size: "30" } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          [
            _vm.loggedInAs.type === "App\\User" && !_vm.reply.by_admin
              ? _c(
                  "router-link",
                  {
                    staticClass: "fw-bold text-dark",
                    attrs: {
                      to: {
                        name: "students.show",
                        params: { student: _vm.reply.ownable.id },
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(_vm.author) + "\n        ")]
                )
              : _c("span", { staticClass: "fw-bold" }, [
                  _vm._v(_vm._s(_vm.author)),
                ]),
            _vm._v(" "),
            _vm.reply.by_admin
              ? _c("i", { staticClass: "fas fa-shield-alt" })
              : _vm._e(),
            _vm._v(" "),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.time(_vm.reply.created_at))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-0", staticStyle: { "white-space": "pre-wrap" } },
          [_vm._v(_vm._s(_vm.reply.body))]
        ),
        _vm._v(" "),
        _vm.reply.image
          ? _c("div", [
              _c("img", {
                staticClass: "img-fluid mt-2",
                attrs: { src: _vm.imageUrl(_vm.reply.image), alt: "" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "d-flex mb-3" },
              [
                _c("Votes", { attrs: { votable: _vm.reply } }),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "me-2" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-dark",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleReplyCreate.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm._f("translate")("Reply")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("ReplyCreate", {
              attrs: {
                comment: _vm.comment,
                reply: _vm.reply,
                show: _vm.replyCreate,
              },
              on: {
                toggleReplyCreate: _vm.toggleReplyCreate,
                replyCreated: _vm.replyCreated,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-link btn-sm",
        attrs: {
          type: "button",
          id: "dropdownMenuButton",
          "data-bs-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fas fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }